import { keys } from 'app/config/keys';
import { NodeEnvironment } from 'app/types';

// Local Typings
interface Flags {
  forceMobilePrompt: boolean; // temporary for demo
  isMobileAppInProduction: boolean;
  isPaperworkInProduction: boolean;

  // ClaimsFlow
  shouldNavigateToClaimFlowStep: null | number;
}

export enum ClaimsFlowNavigationSteps {
  ConfirmYourRelationship = 1,
  AuthenticationCodeModal,
  PaymentTermModal,
  AddBankAccount,
}

// Local Variables
const defaultFlags: Flags = {
  forceMobilePrompt: false,
  isMobileAppInProduction: true,
  isPaperworkInProduction: true,

  // [Kyle 1/09/2020]: ClaimsFlow - Navigate using ClaimsFlowNavigation Enum
  shouldNavigateToClaimFlowStep: null,
};

const devFlags = {
  ...defaultFlags,
  forceMobilePrompt: true,
  shouldNavigateToClaimFlowStep: null,
};

const localFlags = {
  ...devFlags,
};

export const stagingFlags = {
  ...defaultFlags,
  forceMobilePrompt: true,
};
export const prodFlags = { ...defaultFlags };
export const testFlags = { ...defaultFlags };
export const onboardingFlags = { ...defaultFlags };

const flagConfigs: Record<NodeEnvironment, Flags> = {
  development: devFlags,
  local: localFlags,
  onboarding: onboardingFlags,
  production: prodFlags,
  staging: stagingFlags,
  test: testFlags,
};

export function isOnClaimFlowStep(claimFlowStep: number): boolean {
  return (keys.__DEV__ && claimFlowStep === devFlags.shouldNavigateToClaimFlowStep);
}

export function getAppFlags(): Flags {
  return flagConfigs[keys.NODE_ENV || 'production'];
}
